import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../authentication/Auth';
import { analyticsClient } from './client';
import { startMaskedReplay } from './replay';

export default function ReplayTracker() {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();
  const portalId = Number(user?.PortalId ?? user?.portal_id ?? user?.portalId);

  useEffect(() => {
    if (
      process.env.REACT_APP_ANALYTICS_REPLAY_ENABLED !== 'true'
      || !isAuthenticated
      || portalId !== 1
    ) return undefined;
    return startMaskedReplay({
      sessionId: analyticsClient.getSessionId(),
      path: location.pathname,
    });
  }, [isAuthenticated, portalId, location.pathname]);

  return null;
}
